import Snackbar from '@ui/Snackbar/component'
import type { SnackbarConfig } from '@ui/Snackbar/component'

const snackbarsWrapper = document.getElementById('snackbars-wrapper') as HTMLElement

export default {
  initSnackbar(el: HTMLElement, config?: SnackbarConfig): void {
    let snackbarEl = el

    if (el.hasAttribute('data-reusable')) {
      snackbarEl = el.cloneNode(true) as HTMLElement
      snackbarEl.removeAttribute('id')
      snackbarEl.removeAttribute('data-reusable')
    }

    const snackbar = Snackbar(snackbarEl, config)

    if (!snackbar) {
      return
    }

    snackbarsWrapper.appendChild(snackbarEl)
    setTimeout(() => {
      snackbar.show()
    }, 0)
  },
}
